<template>
  <div class="confetti-spinner-circle" :class="{ 'main-spinner': isMain }">
    <div class="confetti-spinner">
      <div class="confetti-circle confetti-circle-1">
        <div class="confetti-circle-inner"></div>
      </div>
      <div class="confetti-circle confetti-circle-2">
        <div class="confetti-circle-inner"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfettiSpinnerCircle",
  props: {
    isMain: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "confetti/scss/components/confetti-spinner-circle";

.confetti-spinner-circle {
  @include confetti-spinner-circle;
}

.confetti-spinner-circle.main-spinner {
  @include confetti-spinner-circle(10rem);

  margin-block-start: 8rem;
}
</style>
